module.exports = __webpack_public_path__ + "img/kit.2a1647d4.png";